import client from "@/api_client/client";
import { EP_PRICING_POLICIES } from "@/constants/endpoints";
import icalService from "@/ical/types/ical.service";
import { ITags } from "@/types/ITags";
import { IPriceSpecification, IPricingPolicy } from "@/types/pricing-policy";

interface IGetArgs {
    id: string;
}

interface IGetPricingPolicyResponse {
    id: string;
    currency: string;
    name: string;
    tags: ITags;
    priceSpecification: IPriceSpecification;
    overrides: Array<IServerOverride>;
}

export interface IServerOverride {
    name: string;
    priceSpecification: IPriceSpecification;
    rules: { schedule: string; };
    tags: ITags & { tt_id: string };
}


export function get(args: IGetArgs): Promise<IPricingPolicy> {
    return client.get<Promise<IGetPricingPolicyResponse>>(`${EP_PRICING_POLICIES}/${args.id}`).then((res) => res.data).then(ppolicy => {
        return {
            ...ppolicy,
            overrides: ppolicy.overrides.map(raw => {
                return {
                    ...raw,
                    rules: {
                        schedule: icalService.parse(raw.rules.schedule),
                    }
                }
            })
        }
    })
}

export function list() {
    return client.get<{ items: Array<IPricingPolicy> }>(`${EP_PRICING_POLICIES}`).then((res) => res.data);
}

type ICreateArgs = {
    policy: IPricingPolicy;
}

export function create(args: ICreateArgs) {
    const overrides = args.policy.overrides.map(o => {

        return {
            ...o,
            rules: {
                schedule: icalService.toString(o.rules.schedule),
            }
        }
    });

    const body = { ...args.policy, overrides };

    return client.put(`${EP_PRICING_POLICIES}/${args.policy.id}`, body).then((res) => res.data);
}

export function remove(args: { id: string }) {
    return client.delete(`${EP_PRICING_POLICIES}/${args.id}`).then((res) => res.data);

}


export default {
    get,
    list,
    create,
    remove,
}